<template>
  <div id="message" class="text-small mx-1" >

    <div class="border default shadow-2 bg-darkBlue  border-radius-8 text-medium p-0 text-just" v-if="instruccion">
      <div class="row fg-white">
        <div class="cell-2 text-center">
            <span class="mif-info mif-5x mt-1"></span>
        </div>
        <div class="cell-10 p-0">
          <div class="row">
            <div class="cell-fs-full">
              <span class="h5">Instrucción</span>
            </div>
            <div class="cell-fs-full pr-5">
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="border default shadow-2 bg-blue  border-radius-8 text-medium text-just" v-if="info">
      <div class="row fg-white">
        <div class="cell-2 text-center p-0">
            <span class="mif-info mif-5x mt-1"></span>
        </div>
        <div class="cell-10">
          <div class="row">
            <div class="cell-fs-full pr-5">
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="border default shadow-2 bg-orange border-radius-8 text-medium p-0 text-just" v-if="warning">
      <div class="row fg-white">
        <div class="cell-2 text-center">
            <span class="mif-info mif-5x mt-1"></span>
        </div>
        <div class="cell-10 p-0">
          <div class="row">
            <div class="cell-fs-full">
              <span class="h5">Atención</span>
            </div>
            <div class="cell-fs-full pr-5">
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="border default shadow-2 bg-red  border-radius-8 text-medium p-0 text-just" v-if="alert">
      <div class="row fg-white">
        <div class="cell-2 text-center">
            <span class="mif-info mif-5x mt-1"></span>
        </div>
        <div class="cell-10 p-0">
          <div class="row">
            <div class="cell-fs-full">
              <span class="h5">Error</span>
            </div>
            <div class="cell-fs-full pr-5">
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="border default shadow-2 bg-green  border-radius-8 text-medium p-0 text-just" v-if="success">
      <div class="row fg-white">
        <div class="cell-2 text-center">
            <span class="mif-info mif-5x mt-1"></span>
        </div>
        <div class="cell-10 p-0">
          <div class="row">
            <div class="cell-fs-full">
              <span class="h5">Completado</span>
            </div>
            <div class="cell-fs-full pr-5">
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  props:{
    nota: false,
    instruccion: null,
    info: null,
    success: null,
    warning: null,
    alert: null,
    message: ''
  },
  methods:{

  }
}
</script>